import { observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";

import { EventOffer, SportOffer } from "@gp/offer";
import { useFormatTennisGameScore } from "@hooks";

export const GameScore = observer(function GameScore(props: {
	sport: SportOffer;
	event: EventOffer;
}) {
	const { t } = useTranslation();
	const gameScore = useFormatTennisGameScore(props.event, props.sport);

	if (!gameScore) {
		return null;
	}

	return (
		<div className="event__stats__item">
			<div className="event__stats__label">{t("EVENT.DETAILS.GAME")}</div>
			<div className="event__stats__result">
				<span>{gameScore.home}</span>
				<span> - </span>
				<span>{gameScore.away}</span>
			</div>
		</div>
	);
});
